import { Flex } from "../mantine-passthroughs/index.js";
import { ElevatedCard } from "../card/ElevatedCard.js";
import { OutlinedCard } from "../card/OutlinedCard.js";
import { VerticalDivider } from "../divider/variants/VerticalDivider.js";
import { Subtitle2 } from "../typography/Subtitle2.js";
import { TextButton } from "../button/TextButton.js";
import { DotIndicator } from "../indicator/DotIndicator.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/components/filter-selection/FilterSelection.tsx
const FilterSelection = ({ onEndIconClick, onInputClick, StartIcon, EndIcon, distance, input, endIconHasNotification = false, inputTestId, endTestId, fullyClickable = false, "data-testid": testId }) => {
	const CardComponent = StartIcon ? OutlinedCard : ElevatedCard;
	const inputSection = StartIcon ? /* @__PURE__ */ jsx(TextButton, {
		LeftIcon: StartIcon,
		wrap: true,
		onClick: onInputClick,
		"data-testid": inputTestId,
		children: /* @__PURE__ */ jsx(Subtitle2, {
			color: "primary",
			children: input
		})
	}) : /* @__PURE__ */ jsx(Subtitle2, { children: input });
	const endSection = EndIcon ? /* @__PURE__ */ jsx(DotIndicator, {
		color: "error",
		disabled: !endIconHasNotification,
		children: /* @__PURE__ */ jsx(EndIcon, { color: "primary" })
	}) : distance ? /* @__PURE__ */ jsx(Subtitle2, {
		color: "gray",
		children: distance
	}) : void 0;
	return /* @__PURE__ */ jsx(CardComponent, {
		onClick: fullyClickable ? onInputClick : void 0,
		"data-testid": testId,
		children: /* @__PURE__ */ jsxs(Flex, {
			align: "center",
			children: [/* @__PURE__ */ jsx(Flex, {
				align: "center",
				flex: 1,
				gap: "xxxs",
				mr: "xxxs",
				role: "button",
				children: inputSection
			}), endSection ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(VerticalDivider, { variant: "middle" }), /* @__PURE__ */ jsx(Flex, {
				"data-testid": endTestId,
				onClick: onEndIconClick,
				px: "xxs",
				pt: "xxs",
				pb: "xxxs",
				children: endSection
			})] }) : void 0]
		})
	});
};

//#endregion
export { FilterSelection };